module.exports = __webpack_public_path__ + "43ca42d388fa41d16988ba36215b421c.jpg";